<template>
  <div class="tag-search">

    <div class="flex">
      <div>
        <span
          style="display: inline-block;width:2px;height: 12px;background: linear-gradient(90deg, #00875e 0%, #0068a9 100%) ;"></span>
        <span style="margin-left: 8px;">{{ $t('筛 选')}}</span>
      </div>
      <span style="text-align: right; cursor: pointer;" @click="clearAll">
        <i class="el-icon-refresh"></i>
        {{ $t('重 置') }}
      </span>
    </div>

    <div class="flex flex-start m-b-24 phone-search-condition" style="width: 100%; margin-top: 14px">
      <div class="table-l" @click="upOrDown" v-if="false">
        <template v-if="isUp">
          <i class="el-icon-arrow-up"></i>
          <span class="font-size-14">{{ $t('Collapes') }}</span>
        </template>
        <template v-else>
          <span class="font-size-14">{{ $t('Expand') }}</span>
          <i class="el-icon-arrow-down"></i>
        </template>
      </div>
      <div class="bl-block" :class="isUp ? '' : 'upHeight'">
        <div class="question-menu-list">
          <ul class="q-menu-first">
            <li v-for="(qItem, index) in questionSite.questionList" :key="qItem.id"
              :class="{ active: levelOneIndex === index }" @click="setListByIndex(index)">
              {{ qItem.aliasName }}
            </li>
          </ul>
          <div class="q-menu-second" v-if="qSecondList.length > 0">
            <table class="bl-table bl-find-c-table" style="width: 100%">
              <tbody>
                <template v-if="hasLevelThree">
                  <tr v-for="qItem in qSecondList" :key="qItem.id">
                    <td class="bl-table-head">{{ qItem.aliasName }}</td>
                    <td>
                      <div class="tag-col-list">
                        <div :ref="'tag-col-' + levelOneIndex">
                          <template v-if="curQuestion.selectedType !== 'multiple'">
                            <el-radio-group v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, qItem, questionSite.questionList[levelOneIndex])">
                              <el-radio :label="item.id" v-for="item in qItem.subAnswerList" :key="item.id"
                                :disabled="selectDisable && !isInSelectedList(item.id)">{{ item.aliasName }}</el-radio>
                            </el-radio-group>
                          </template>
                          <template v-else>
                            <el-checkbox-group v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, qItem, questionSite.questionList[levelOneIndex])">
                              <el-checkbox :label="item.id" v-for="item in qItem.subAnswerList" :key="item.id"
                                :disabled="(selectDisableList[item.questionId] || selectDisable) && !isInSelectedList(item.id)"
                                size="mini" class="tagMultipleBtn" border>
                                {{ item.aliasName }}
                              </el-checkbox>
                            </el-checkbox-group>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td>
                      <div class="tag-col-list">
                        <div :ref="'tag-col-' + levelOneIndex">
                          <template v-if="curQuestion.selectedType !== 'multiple'">
                            <el-radio-group v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, questionSite.questionList[levelOneIndex])">
                              <el-radio :label="item.id" v-for="item in qSecondList" :key="item.id"
                                :disabled="selectDisable && !isInSelectedList(item.id)">{{ item.aliasName }}</el-radio>
                            </el-radio-group>
                          </template>
                          <template v-else>
                            <el-checkbox-group v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, questionSite.questionList[levelOneIndex])">
                              <el-checkbox :label="item.id" v-for="item in qSecondList" :key="item.id"
                                :disabled="(selectDisableList[item.questionId] || selectDisable ) && !isInSelectedList(item.id)"
                                size="mini" class="tagMultipleBtn" border>{{ item.aliasName }}</el-checkbox>
                            </el-checkbox-group>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="tc">
      <span class="searchBox" @click="checkBox(item)" :class="checkInfo == item.key ? 'isCheck' : ''"
        v-for="(item, index) in searchBoxList" :key="index">{{ language == 'en' ? item.enName : item.name }}</span>
    </div>

    <!-- 全部选择按钮 -->
    <template v-if="false">
      <div class="v-search-btn v-search-co-btn text-right phone-search-btn">
        <el-button class="pointer" type="primary" size="mini-xs" @click="filterQuery"
          :disabled="checkList.join('') == ''">{{ $t('finds.sure') }}</el-button>
      </div>
      <template v-if="selectedList && Object.keys(selectedList).length > 0">
        <span class="bl-find-condition__sTitle" @click="clearAll">{{ $t('common.clearCondition') }}<i
            class="el-icon-arrow-right"></i></span>
        <div class="bl-find-condition__selected">
          <template v-for="item in selectedList">
            <label v-for="(lItem, index) in item" :key="lItem.id">
              <span>{{ lItem.names[0] }}：</span>
              <font>{{ lItem.name }}</font>
              <i class="el-icon-close" @click="cClose(lItem, index)"></i>
            </label>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
  },
  props: {
    questionSite: {
      type: Object,
      default: () => {
        return {}
      }
    },
    questionList: {
        type: Array,
        default: () => {
            return []
        }
    }
  },
  data: () => ({
    isUp:true,
    checkList: [],
    selectedList: {},
    levelOneIndex: 0,
    qSecondList: [],
    hasLevelThree: false, // 是否有三级
    selectDisable: false,
    selectDisableList: {},
    curQuestion: {},
    checkInfo: '',
    searchBoxList: [
      { "key": "A", "name": "A", "enName": "A" },
      { "key": "B", "name": "B", "enName": "B" },
      { "key": "C", "name": "C", "enName": "C" },
      { "key": "D", "name": "D", "enName": "D" },
      { "key": "E", "name": "E", "enName": "E" },
      { "key": "F", "name": "F", "enName": "F" },
      { "key": "G", "name": "G", "enName": "G" },
      { "key": "H", "name": "H", "enName": "H" },
      { "key": "I", "name": "I", "enName": "I" },
      { "key": "J", "name": "J", "enName": "J" },
      { "key": "K", "name": "K", "enName": "K" },
      { "key": "L", "name": "L", "enName": "L" },
      { "key": "M", "name": "M", "enName": "M" },
      { "key": "N", "name": "N", "enName": "N" },
      { "key": "O", "name": "O", "enName": "O" },
      { "key": "P", "name": "P", "enName": "P" },
      { "key": "Q", "name": "Q", "enName": "Q" },
      { "key": "R", "name": "R", "enName": "R" },
      { "key": "S", "name": "S", "enName": "S" },
      { "key": "T", "name": "T", "enName": "T" },
      { "key": "U", "name": "U", "enName": "U" },
      { "key": "V", "name": "V", "enName": "V" },
      { "key": "W", "name": "W", "enName": "W" },
      { "key": "X", "name": "X", "enName": "X" },
      { "key": "Y", "name": "Y", "enName": "Y" },
      { "key": "Z", "name": "Z", "enName": "Z" },
      { "key": "ALL", "name": "全部", "enName": "ALL" },
    ],
  }),
  watch: {
    questionSite: {
        handler() {
            this.setListByIndex(0)
            this.checkListInit()
        },
        immediate: true
    },
    selectedList: {
        handler() {
            this.$emit('update:questionListValue', this.getQuestionList())
        },
        deep: true
    }
  },
  methods: {
    // 选中筛选条件
    checkBox(item) {
      this.checkInfo = item.key
      this.$emit('update:checkInfoValue', this.checkInfo)
      // 搜索
      this.filterQuery()
    },
    // 默认选中分类
    setListByIndex(index) {
      let item = this.questionSite.questionList[index]
      this.levelOneIndex = index
      this.curQuestion = item
      if (item.answerList && item.answerList.length > 0) {
        this.qSecondList = this.questionSite.questionList[index].answerList
      } else {
        this.qSecondList = []
      }

      this.hasLevelThree = false
      for (let i = 0; i < this.qSecondList.length; i++) {
        if (!this.qSecondList[i].leaf) {
          this.hasLevelThree = true
          break
        }
      }

      // used in addSelectVal
      if (this.hasLevelThree) {
        this.qSecondList.forEach(item => {
          let _item = JSON.parse(JSON.stringify(item))
          if (item.leaf) {
            delete _item.subAnswerList
            item.leaf = false
            item.answerList = [_item]
          } else {
            item.answerList = _item.subAnswerList
          }
        })
      }
    },
    filterQuery() {
      // 筛选查询
      setTimeout(() => {
        this.$emit("searchList")
      }, 0)
    },
    // 展开关闭
    upOrDown() {
      if(this.isUp) { 
        this.isUp = false
      } else {
        this.isUp = true
      }
    },
    // 添加选中值
    addSelectVal(index, data, data2) {
      let pId = data.questionId || data.id
      let names = []
      let checkedArray = this.checkList[index]
      if (data2) {
        names.push(data2.aliasName)
      }
      names.push(data.aliasName)
      if (!this.selectedList[pId]) {
        this.$set(this.selectedList, pId, [])
      }

      if (this.curQuestion.selectedType !== 'multiple') {
        // 单选
        let a = this.selectedList[pId].filter(item => {
          return item.id === checkedArray
        })

        if (a.length > 0) return

        let c = data.answerList.filter(i => {
          return i.id === checkedArray
        })
        if (c.length == 0) return
        names.push(c[0].aliasName)
        this.$set(this.selectedList[pId], 0, {
          id: checkedArray,
          pId: pId,
          pIndex: index,
          names: names,
          name: c[0].aliasName,
          index: c[0].sequence - 1,
          data: c[0]
        })
      } else {
        // 多选
        if (checkedArray.length === 0) {
          this.selectedList[pId] = []
        } else {
          let sData = []
          this.selectedList[pId].forEach(item => {
            if (checkedArray.indexOf(item.id) > -1) {
              sData.push(item)
            }
          })
          this.selectedList[pId] = sData
        }

        checkedArray.forEach(item => {

          let b = this.selectedList[pId].filter(cItem => {
            return cItem.id === item
          })

          if (b.length === 0) {
            let c = data.answerList.filter(i => {
              return i.id === item
            })
            if (c.length == 0) return
            names.push(c[0].aliasName)
            this.selectedList[pId].push({
              id: item,
              pId: pId,
              pIndex: index,
              names: names,
              name: c[0].aliasName,
              index: c[0].sequence - 1,
              data: c[0]
            })
          }
          
        })
      }
      // 搜索
      this.filterQuery()
    },
    // 初始化选中值
    checkListInit() {
        if (this.questionSite.questionList && this.questionSite.questionList.length > 0) {
            this.questionSite.questionList.forEach((item, index) => {
                if (item.selectedType == 'multiple') {
                    this.$set(this.checkList, index, [])
                } else {
                    this.$set(this.checkList, index, '')
                }
            })
        }
    },
    // 清空搜索条件
    clearAll() {
      this.checkInfo = ''
      this.$emit('update:checkInfoValue', this.checkInfo)
      this.selectedList = {}
      this.checkListInit()
      this.filterQuery()
    },
    // 删除搜素条件
    cClose(data, index) {
      this.selectedList[data.pId].splice(index, 1)
      let cIndex = 0

      if (this.selectedList[data.pId].length == 0) {
        delete this.selectedList[data.pId]
      }

      if (this.curQuestion.selectedType !== 'multiple') {
        this.checkList.some((item, index) => {
          if (item == data.id) {
            cIndex = index
            return
          }
        })
        this.checkList[cIndex] = ''
      } else {
        this.checkList[data.pIndex].some((item, index) => {
          if (item == data.id) {
            cIndex = index
            return
          }
        })
        this.checkList[data.pIndex].splice(cIndex, 1)
      }
      this.filterQuery()
    },
    // 选中状态
    isInSelectedList(id) {
      let boolean = false
      Object.keys(this.selectedList).forEach(item => {
        this.selectedList[item].forEach(tag => {
          if (tag.id === id) {
            boolean = true
          }
        })
      })
      return boolean
    },
    // 获取 筛选内容
    getQuestionList() {
      let questionList = []
      for (var k in this.selectedList) {
        let data = {
          questionId: k,
          answerIds: [],
          tagNames: []
        }
        this.selectedList[k].forEach(item => {
          data.answerIds.push(item.id)
          data.tagNames.push(item.name)
        })
        if (data.answerIds.length > 0) {
          questionList.push(data)
        }
      }
      return questionList
    },
  }
}
</script>
<style lang="stylus" scoped>
.tag-search
  overflow hidden
  padding:20px;
  .table-l
    margin-right: 0

  .upHeight
    height 42px
    overflow hidden

    .question-menu-list .q-menu-second 
      overflow hidden

  .bl-block
    flex: 1
    overflow: hidden
    border 1px solid #e5e5e5
    // box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);

  .question-menu-list
    position relative
    width 100%
    .q-menu-second
      width 780px
      width calc(100% - 200px)
      background-color $color-gray-f5
    .q-menu-first,
    .q-menu-second
      height 300px
      overflow-y auto

    .q-menu-first
      position: relative
      width 200px
      float left
      &::before
        content ''
        position absolute
        top 0
        right 0
        width 2px
        height 100%
        background $border-color-e5
      li
        position relative
        text-align center
        min-height 42px
        line-height 22px
        padding 10px
        font-size 14px
        cursor pointer
        z-index 10

        &:hover
          background $color-light9

        &.active
          background: linear-gradient(90deg, #00875e 0%, #0068a9 100%) !important;
          color $color-white

    .bl-table-head
      line-height 22px
      padding 10px
      vertical-align middle
      text-align center
      background-color $color-gray-fb
      white-space nowrap

  .bl-find-condition__sTitle
    float: left;
    margin-top: 6px;
    min-width: 90px;
    cursor: pointer;

    &:hover
      text-decoration underline
      color $color-main

  .bl-find-condition__selected{
    width: 100%;
    padding-left: 90px;
    min-height: 35px;

    & > label{
        display: inline-block;
        margin: 5px;
        padding: 2px 10px;
        background-color: $color-light9;
        line-height 20px;
        font-size: 14px;

        font{
            margin-left: 2px;
            margin-right: 14px;
            color: $color-main;
        }

        *{
            vertical-align: middle;
        }

        i{
            cursor pointer
            transition: all .5s;
        }

        &:hover {
            i {
                color: $color-main;
                transform: rotate(180deg)
            }
        }
    }
  }

  .bl-find-c-table
    border none
    background $color-gray-fb
    td
      padding-top 6px
      padding-bottom 6px
      position relative
      border-top none
      border-right none
      border-width 6px
      border-color $color-gray-fb
      background-color $color-gray-f5
    tr:last-child
      td
        border-bottom none

    tr
      & >td:first-child
        border-left none
    
    >>> .el-radio__label 
      display inline-block
      line-height 20px

    .el-radio
      margin 5px 8px
      min-width 80px
    .el-checkbox
      margin 5px 8px
      min-width 80px
      border-radius:50px;
      
      
.tagMultipleBtn
  text-align center
  ::v-deep.el-checkbox__input
      display none !important
  ::v-deep.el-checkbox__label
    padding-left 0px !important

::v-deep.is-checked{
  background: linear-gradient(90deg, #00875e 0%, #0068a9 100%) !important;
  color:#fff;
  .el-checkbox__label{
    color:#fff;  
  }
}
.searchBox{
	padding: 5px 8px;
	border-radius: 4px;
	background: #FFFFFF;
	box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
	border-radius: 2px;
	border: 1px solid rgba(0, 0, 0, 0.15);
	display: inline-block;
	margin: 4px;
	font-size: 12px;
	color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
}
.isCheck{
	background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
	color: #fff;
  cursor: pointer;
}

@media (min-width: 320px) and (max-width: 750px) {
  .tag-search{
    .question-menu-list{
      .q-menu-second{
        width: calc(100% - 100px);
      }
      .q-menu-first{
        width:100px;
      }
    }
  }
  

    
}
</style>
